type ParsedNudgeText = {
  boldText: string;
  normalText: string;
};

/**
 * nudge_text HTML을 파싱합니다.
 * 예: "<b>11,000원</b> 비싸져요" → { boldText: "11,000원", normalText: " 비싸져요" }
 */
export const parseNudgeText = (html: string): ParsedNudgeText | null => {
  const boldMatch = html.match(/<b>([^<]+)<\/b>(.*)/);
  if (boldMatch) {
    return {
      boldText: boldMatch[1],
      normalText: boldMatch[2],
    };
  }

  const spanMatch = html.match(/<span[^>]*>([^<]+)<\/span>(.*)/);
  if (spanMatch) {
    return {
      boldText: spanMatch[1],
      normalText: spanMatch[2],
    };
  }

  return null;
};
